const EarningBreakdown = () => {
  return (
    <div className="flex flex-col pt-5 px-3 gap-2 min-h-0">
      <span className="font-bold text-sm">Earning breakdown</span>
      <div className="grid grid-cols-[1.5fr_1.5fr_1fr_1fr_1fr] bg-[#FAFAFA] rounded-md py-2.5 px-8">
        <span className="text-xs font-semibold text-light-black">
          Candidate
        </span>
        <span className="text-xs font-semibold text-light-black">Job Role</span>
        <span className="text-xs font-semibold text-light-black">Status</span>
        <span className="text-xs font-semibold text-light-black">Amount</span>
        <span className="text-xs font-semibold text-light-black">Date</span>
      </div>
      {/* List */}
      <div className="flex flex-col min-h-0 overflow-y-scroll no-scrollbar">
        {Array.from({ length: 20 })?.map(() => {
          return (
            <div className="grid grid-cols-[1.5fr_1.5fr_1fr_1fr_1fr] rounded-md px-8 py-2.5">
              <span className="text-xs font-medium text-primary">
                Courtney Henry
              </span>
              <span className="text-xs font-medium text-primary">
                Software Engineer
              </span>
              <span className="text-xs font-medium text-primary">Pending</span>
              <span className="text-xs font-medium text-primary">£120</span>
              <span className="text-xs font-medium text-primary">
                12 Nov 2025
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EarningBreakdown;
